import { useState, useEffect, useMemo } from 'react'
import Portal from './portal'
import { isLocalhost, portalHost } from '../environment'
import styles from './meshsite.module.css'
import { MeshAppBridge } from '../meshAppBridge/bridge'

type Props = {
  bridge: MeshAppBridge
}

function getHashParam(): string {
  const hash = window.location.hash
  return hash && hash.length > 1 ? hash.slice(1) : ''
}

export default function MeshSite({ bridge }: Props) {
  const [loadSiteName, setLoadSiteName] = useState<string>('')
  const [param, setParam] = useState<string>(getHashParam)

  useEffect(() => {
    setLoadSiteName(window.location.pathname)
  }, [])

  useEffect(() => {
    const onHashChange = () => setParam(getHashParam())
    window.addEventListener('hashchange', onHashChange)
    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  const loadSiteURL = useMemo(() => {
    const paramPart = param ? `&param=${encodeURIComponent(param)}` : ''
    if (isLocalhost) {
      return `${portalHost}/site#site=${encodeURIComponent(loadSiteName)}${paramPart}`
    }

    return loadSiteName
      ? `${portalHost}/iframe.html#site=${encodeURIComponent(loadSiteName)}${paramPart}`
      : ''
  }, [loadSiteName, param])

  console.log('Load site URL: ' + loadSiteURL)

  return (
    <div className={styles.meshsite}>
      {loadSiteName && (
        <Portal key={param} bridge={bridge} loadSiteName={loadSiteURL} />
      )}
    </div>
  )
}
